import CloseButton from "../../../../../components/CloseButton";
import AnalysisSelectionPage from "./analysis/AnalysisSelectionPage";
import ComprehensiveSelectionPage from "./comprehensive/ComprehensiveSelectionPage";
import VocabularySelectionPage from "./vocabulary/VocabularySelectionPage";
import SentenceSelectionPage from "./sentence/SentenceSelectionPage";
import GrammarSelectionPage from "./grammar/GrammarSelectionPage";
import { allTypes } from "../../WorksheetModal/constants";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 고정 500px → max-width 520px + 반응형 (모바일 전체 화면)
 * 2. 콘텐츠 스크롤 영역과 하단 고정 바 분리
 * 3. onClickPrev 추가 → 이전/다음 버튼
 */
const TypeSelectionPage = ({
  worksheet,
  onClose,
  onClickPrev,
  onClickNext,
  selectedTypes,
  setSelectedTypes,
}) => {
  return (
    <div
      
      style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "calc(80vh - 62px)", overflow: "hidden" }}
    >
      <CloseButton onClick={onClose} />

      <div className="ws-scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
        {worksheet.type === "analysis" && (
          <AnalysisSelectionPage
            allTypes={allTypes}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "comprehensive" && (
          <ComprehensiveSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "vocabulary" && (
          <VocabularySelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "sentence" && (
          <SentenceSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "grammar" && (
          <GrammarSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
      </div>

      {onClickNext && (
        <div className="ws-bottom-bar">
          {onClickPrev && (
            <button className="ws-btn-prev" onClick={onClickPrev}>
              이전
            </button>
          )}
          <button className="ws-btn-next" onClick={onClickNext}>
            다음
          </button>
        </div>
      )}
    </div>
  );
};

export default TypeSelectionPage;
